import { useFeatureEnabled } from 'api/appConfig';
import { S4Feature } from 'types/api';

// Single source of truth for whether Cross-App Access (XAA / ID-JAG) is enabled.
// Every XAA surface - home card, sidebar section, select page/route, JIT toggle and
// the guide - gates on this, so turning the feature off removes XAA everywhere.
// XAA is opt-in: useFeatureEnabled reads the positive xaaEnabled feature, so a project
// that never turned it on gets false.
const useIsXaaEnabled = (): boolean => {
	const { enabled } = useFeatureEnabled(S4Feature.Xaa);
	return enabled;
};

export default useIsXaaEnabled;
